module.exports = __webpack_public_path__ + "static/img/img(5).43636e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(5).png
// module id = 02qO
// module chunks = 1